import { CdhAccent } from 'components/general/Accent/variants';
import LabeledInput from 'components/general/inputs/LabeledInput';
import LabeledSelect from 'components/general/inputs/LabeledSelect';
import { ISelectOption } from 'components/general/types';
import { IFiniteStateMachine, IStateTransition, TRoutine } from 'components/general/types/cdh';
import WidgetTable from 'components/general/widgets/WidgetTable';
import useStyles from 'components/general/wizards/WizardSegment/styles';
import { useActiveEntities } from 'hooks';
import { ITableBlock } from 'hooks/useSelectBlocks';
import { ChangeEvent, useContext, useState } from 'react';
import { IRoutineFormProps } from '.';
import { conditionsTableColumns } from '../../ConditionsSegment';
import { RoutineContext, useRoutineState } from '../RoutinesWidget';

export const StateTransitionForm = (props: IRoutineFormProps) => {
  const { id } = props;
  const { classes } = useStyles();
  const { conditions } = useActiveEntities();
  const { data: transition, setValue } = useRoutineState<IStateTransition>(id);
  const { state } = useContext(RoutineContext);
  const [tableData, setTableData] = useState<ITableBlock[]>(
    conditions.map((condition) => ({
      ...condition,
      tableData: { checked: transition.conditions.includes(condition.id) },
    }))
  );

  return (
    <div style={{ paddingLeft: 20 }}>
      <h3>{`${(state.blocks[transition.fromState] as TRoutine).name} → ${
        (state.blocks[transition.toState] as TRoutine).name
      }`}</h3>
      <div>
        <LabeledInput
          label="Priority"
          name="priority"
          value={transition.priority}
          type="number"
          onChange={(e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value, 'priority')}
        />
        <div className={classes.inputGroup}>
          <CdhAccent header="Conditions">
            <WidgetTable
              className={classes.table}
              columns={conditionsTableColumns}
              data={tableData}
              setData={setTableData}
              onSelectionChange={(data: ITableBlock[]) =>
                setValue(
                  data.filter(({ tableData }) => tableData.checked).map(({ id }) => id),
                  'conditions'
                )
              }
              emptyMessage={'No conditions found'}
              title="Select Conditions"
              search={true}
              selection={true}
            />
          </CdhAccent>
        </div>
      </div>
    </div>
  );
};

const FiniteStateMachineForm = (props: IRoutineFormProps) => {
  const { id } = props;
  const { data: routine, setValue } = useRoutineState<IFiniteStateMachine>(id);
  const { state } = useContext(RoutineContext);

  return (
    <LabeledSelect
      label="Initial Subroutine"
      name="activeSubroutine"
      value={
        routine.activeSubroutine && {
          value: routine.activeSubroutine,
          label: (state.blocks[routine.activeSubroutine] as TRoutine).name,
        }
      }
      options={routine.subroutines.map((id) => ({
        value: id,
        label: (state.blocks[id] as TRoutine).name,
      }))}
      onChange={(value: ISelectOption) => setValue(value.value, 'activeSubroutine')}
      menuPosition="fixed"
    />
  );
};

export default FiniteStateMachineForm;
